"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = require("react-select");

var _postcodeSearchableListModule = _interopRequireDefault(require("./postcodeSearchableList.module.css"));

var _constants = require("../../../utils/constants");

var _functions = require("../../../utils/functions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var reactSelectCustomStyles = {
  control: function control(provided, state) {
    return _objectSpread({}, provided, {
      border: '1px solid #d8d8d8',
      borderRadius: '0px',
      boxShadow: '0 1px 3px #d8d8d8 inset',
      '&:hover': {
        border: '1px solid #d8d8d8'
      },
      minHeight: 36,
      backgroundColor: state.isDisabled ? 'rgba(176,176,176,0.1)' : 'inherit',
      pointerEvents: state.isDisabled ? 'auto' : 'default',
      cursor: state.isDisabled ? 'not-allowed' : 'default'
    });
  },
  container: function container(base) {
    return _objectSpread({}, base, {
      minHeight: 34
    });
  },
  placeholder: function placeholder(base, state) {
    return _objectSpread({}, base, {
      fontWeight: 'normal',
      fontFamily: "Arial, sans-serif",
      fontSize: "15px",
      color: state.isDisabled ? 'rgba(169,169,169,1)' : '#000'
    });
  },
  loadingIndicator: function loadingIndicator(base) {
    return _objectSpread({}, base, {
      marginRight: '18px'
    });
  },
  dropdownIndicator: function dropdownIndicator(base) {
    return _objectSpread({}, base);
  },
  clearIndicator: function clearIndicator(base) {
    return _objectSpread({}, base, {
      paddingTop: 0,
      paddingBottom: 0,
      color: "#000",
      marginRight: '28px',
      position: "absolute",
      top: 8,
      right: 0
    });
  },
  indicatorsContainer: function indicatorsContainer(base) {
    return _objectSpread({}, base, {
      display: 'flex',
      alignItems: "center"
    });
  },
  indicatorSeparator: function indicatorSeparator(base) {
    return {
      display: 'none'
    };
  },
  input: function input(provided, state) {
    return _objectSpread({}, provided, {
      margin: 0,
      padding: 0,
      fontFamily: 'arial, sans-serif',
      color: 'black',
      input: {
        opacity: "1 !important",
        '&:disabled': {
          color: ' #969696 !important'
        }
      }
    });
  },
  menu: function menu(provided, state) {
    return _objectSpread({}, provided, {
      zIndex: 3
    });
  },
  option: function option(base) {
    return _objectSpread({}, base, {
      fontFamily: 'arial, sans-serif',
      color: 'black',
      fontSize: '1em; color: #000'
    });
  }
};

var LoadingIndicator = function LoadingIndicator(props) {
  return _react.default.createElement("span", {
    id: props.instanceId ? "".concat(props.instanceId, "_loader") : null,
    className: _postcodeSearchableListModule.default["loader"]
  });
};

var PostcodeSearchableList = function PostcodeSearchableList(props) {
  var regex = props.regex,
      url = props.url,
      headers = props.headers,
      placeholder = props.placeholder,
      loadingMessage = props.loadingMessage,
      onChange = props.onChange,
      onBlur = props.onBlur,
      inputValue = props.inputValue,
      id = props.id,
      inputId = props.inputId,
      instanceId = props.instanceId,
      name = props.name,
      isDisabled = props.isDisabled,
      setInputValue = props.setInputValue,
      timeOutInMilliseconds = props.timeOutInMilliseconds,
      noOptionsMessage = props.noOptionsMessage,
      cacheOptions = props.cacheOptions,
      onFocus = props.onFocus,
      token = props.token,
      autoComplete = props.autoComplete;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      postcodeOptions = _useState2[0],
      setOptions = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var handleOptionsLoad =
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2() {
      var url,
          headers,
          inputValue,
          regex,
          timeOutInMilliseconds,
          requiredTimeOutInMilliseconds,
          addresses,
          _args2 = arguments;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              url = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : null;
              headers = _args2.length > 1 ? _args2[1] : undefined;
              inputValue = _args2.length > 2 ? _args2[2] : undefined;
              regex = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : false;
              timeOutInMilliseconds = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : 0;
              requiredTimeOutInMilliseconds = timeOutInMilliseconds ? timeOutInMilliseconds : 5000;
              setLoading(true);
              _context2.prev = 7;
              _context2.next = 10;
              return (0, _functions.promiseWithTimeout)((0, _functions.requestWithPromise)((0, _functions.craftyClicksUrl)(url, inputValue, token), headers), requiredTimeOutInMilliseconds).then(
              /*#__PURE__*/
              function () {
                var _ref2 = _asyncToGenerator(
                /*#__PURE__*/
                regeneratorRuntime.mark(function _callee(result) {
                  var data;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return result.json();

                        case 2:
                          data = _context.sent;
                          addresses = (0, _functions.transformAddressesForOptions)(data);

                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }()).catch(function (err) {
                return [];
              });

            case 10:
              _context2.next = 15;
              break;

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](7);
              addresses = [];

            case 15:
              setLoading(false);
              setOptions(addresses);
              return _context2.abrupt("return", addresses);

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[7, 12]]);
    }));

    return function handleOptionsLoad() {
      return _ref.apply(this, arguments);
    };
  }();

  var onInputChange = function onInputChange(value, action) {
    if (action.action !== 'input-blur' && action.action !== 'menu-close' && action.action !== 'set-value') {
      setInputValue(value);
    }
  };

  return _react.default.createElement(_reactSelect.Async, {
    inputValue: inputValue,
    id: id,
    inputProps: {
      autoComplete: autoComplete ? autoComplete : ""
    },
    inputId: inputId,
    instanceId: instanceId,
    name: name,
    components: {
      LoadingIndicator: LoadingIndicator,
      DropdownIndicator: function DropdownIndicator() {
        return null;
      }
    },
    value: inputValue,
    cacheOptions: cacheOptions,
    defaultOptions: !!inputValue ? postcodeOptions : [],
    styles: reactSelectCustomStyles,
    onInputChange: onInputChange,
    onChange: onChange,
    onBlur: onBlur,
    loadOptions: function loadOptions() {
      return handleOptionsLoad(url, headers, inputValue, regex, timeOutInMilliseconds);
    },
    isDisabled: isDisabled,
    isLoading: loading,
    noOptionsMessage: noOptionsMessage ? function () {
      return noOptionsMessage && postcodeOptions && Array.isArray(postcodeOptions) && postcodeOptions.length === 0 ? noOptionsMessage : null;
    } : undefined,
    loadingMessage: loadingMessage ? loadingMessage : undefined,
    placeholder: placeholder,
    blurInputOnSelect: false,
    closeMenuOnSelect: true,
    onFocus: onFocus
  });
};

PostcodeSearchableList.propTypes = {
  /** String for Regular expression to validate the input before the request
   *  Default value: ^[a-zA-Z]{1,2}[0-9][a-zA-Z0-9]? ?[0-9][a-zA-Z]{2}$*/
  regex: _propTypes.default.string,

  /** String text that enables or disable the browser to offer autocompletion */
  autoComplete: _propTypes.default.string,

  /** String for url of the service */
  url: _propTypes.default.string,

  /** Object for headers if url needs */
  headers: _propTypes.default.object,

  /** String for input placeholder */
  placeholder: _propTypes.default.string,

  /** Callback invoked when the user press an option in the list. It will pass the values with the addresses from the request
   * eg: (values) => {}
   * The structure of the values is object with properties:
   * county: string
   label: string
   lines: object with properties:{
   line1: string
   line2: string || null
   line3: string || null
   }
   postcode: string
   town: string*/
  onChange: _propTypes.default.func.isRequired,

  /** Callback invoked on blur. An event argument will be available. eg: (evt) => {} */
  onBlur: _propTypes.default.func,

  /** The id of the component */
  id: _propTypes.default.string,

  /** The id of the search input */
  inputId: _propTypes.default.string,

  /** Define an id prefix for the select components e.g. {your-id}-value */
  instanceId: _propTypes.default.string,

  /** The name of the search input */
  name: _propTypes.default.string,

  /** Boolean indicating if the input is disabled or not */
  isDisabled: _propTypes.default.bool,

  /** Callback invoked when the input is change. It will be passed the new value of the input
   * eg: (value) => {} */
  setInputValue: _propTypes.default.func.isRequired,

  /** The number in milliseconds to stop the request.
   *  Default value: 5000 (5 seconds) */
  timeOutInMilliseconds: _propTypes.default.number,

  /** String for Text to display when there are no options */
  noOptionsMessage: _propTypes.default.func,

  /** If cacheOptions is truthy, then the loaded data will be cached. The cache will remain until
   *  cacheOptions changes value. */
  cacheOptions: _propTypes.default.bool,

  /** Handle focus events on the control */
  onFocus: _propTypes.default.bool
};
var _default = PostcodeSearchableList;
exports.default = _default;